import React, { ReactNode } from 'react';

import { Avatar, Flex, Typography } from 'antd';

import { ICreateShipmentAddress } from '@/models/address';

interface IAddressSummaryCardProps {
  label: string;
  icon: ReactNode;
  address: ICreateShipmentAddress | undefined;
  email: string | undefined;
}

const AddressSummaryCard = ({
  label,
  icon,
  address,
  email,
}: IAddressSummaryCardProps) => {
  if (!address) return null;

  const name =
    address.company ||
    [address.firstName, address.lastName].filter(Boolean).join(' ');
  const streetLine = [address.street, address.houseNumber]
    .filter(Boolean)
    .join(' ');
  const cityLine = [address.postalCode, address.city, address.countryCode]
    .filter(Boolean)
    .join(', ');

  if (!address.street && !address.city) {
    return <Typography.Text type="secondary">No address</Typography.Text>;
  }

  return (
    <Flex gap="0.75rem" align="flex-start">
      <Avatar
        size={40}
        icon={icon}
        style={{ background: '#f5f5f5', color: '#8c8c8c', flexShrink: 0 }}
      />
      <Flex vertical gap="0.125rem">
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {label}
        </Typography.Text>
        {name && <Typography.Text strong>{name}</Typography.Text>}
        {streetLine && <Typography.Text>{streetLine}</Typography.Text>}
        {cityLine && <Typography.Text>{cityLine}</Typography.Text>}
        {email && (
          <Typography.Text type="secondary">Mail: {email}</Typography.Text>
        )}
      </Flex>
    </Flex>
  );
};

export { AddressSummaryCard };
